export const LOGIN_ROUTE_PATH = '/login'
